import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Self-qualification "is this you?" routing block.
export const RoutingBlock = ({ title, items, to, cta, testId }) => {
  return (
    <div
      className="border border-sage/60 rounded-[2px] p-6 sm:p-8 bg-bone flex flex-col"
      data-testid={testId}
    >
      <h3 className="font-display text-2xl text-spruce mb-4">{title}</h3>
      <ul className="space-y-2 mb-6 flex-1">
        {items.map((it, i) => (
          <li key={i} className="text-sm text-ink/85 leading-relaxed flex gap-2">
            <span className="text-sage mt-1">—</span>
            <span>{it}</span>
          </li>
        ))}
      </ul>
      <Link
        to={to}
        className="inline-flex items-center gap-2 text-sm font-semibold text-spruce hover:text-brass transition-colors group"
        data-testid={`${testId}-link`}
      >
        {cta}
        <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  );
};

export default RoutingBlock;
